/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/selectedCredentials.config.json';
import notification from '../config/notifications.config.json';
import axios from 'axios';

import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { SELECTED_CREDENTIALS } from '../graphql';
import { VApplication } from '../../../application';
import { useTemplateId } from '../../../pages/EPortfolioCertificates/provider';
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export interface ISelectedCredentialsMethods extends IPluginMethodMap {
  getSelectedCredentials(args: any): Promise<any>;
}

export interface SelectedCredentialsProps {
  id: string[];
}

export class SelectedCredentialsService implements IAgentPlugin {
  readonly methods: ISelectedCredentialsMethods;

  constructor() {
    this.methods = {
      getSelectedCredentials: this.getSelectedCredentials.bind(this),
    };
  }

  async getSelectedCredentials(args: SelectedCredentialsProps) {
    const { uuid} = useTemplateId();
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient('graphql-gateway');
    console.log("ssd", uuid)
    try {
      if (client) {
        const res = await client.mutate({
          mutation: SELECTED_CREDENTIALS,
          variables: {
            filter:{
              uuid: uuid
            },
            update: {
              credentials: args
            }

          },
          fetchPolicy: 'no-cache',
        });
        if (res?.data?.selectedCredentials?.message) {
          return {
            notification: notification?.selectedCredentials,
          };
        } else {
          return {
            notification: notification?.selectedCredentials,
          };
        }
      }
    } catch (err: any) {
      // console.log("error in revoke credential", err?.message);
      throw err;
    }
  }
}
